export const ApplicationType = {
    Web: 'Web',
    Mobile: 'Mobile'
  } 


// WEBPACK FOOTER //
// ./src/constants/type.js